import React from 'react';
import { Box, Container, Typography, Stack, Divider } from '@mui/material';
import { Link } from 'react-router-dom';
import MovdLogo from './MovdLogo.jsx';

const navLinks = [
  { label: 'How It Works', to: '/how-it-works' },
  { label: 'About Us', to: '/about' },
  { label: 'FAQ', to: '/faq' },
  { label: 'Contact', to: '/contact' },
  { label: 'Blog', to: '/blog' },
];

const legalLinks = [
  { label: 'Mover Login', to: '/?portal=mover-login', external: false },
  { label: 'Apply as a Mover', to: '/become-partner', external: false },
  { label: 'Privacy Policy', to: '/privacy-policy.html', external: true },
  { label: 'Terms of Service', to: '/terms.html', external: true },
];

const linkSx = {
  color: 'rgba(255,255,255,0.45)',
  fontSize: 14,
  textDecoration: 'none',
  '&:hover': { color: '#fff' },
  transition: 'color 0.15s',
};

export default function Footer() {
  return (
    <Box component="footer" sx={{ bgcolor: '#020617', color: 'rgba(255,255,255,0.5)', pt: 6, pb: 4 }}>
      <Container maxWidth="lg">
        {/* Top row */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 4, mb: 4 }}>
          {/* Brand */}
          <Box sx={{ minWidth: 160 }}>
            <MovdLogo size="small" variant="full" color="white" />
            <Typography variant="body2" sx={{ mt: 1.5, color: 'rgba(255,255,255,0.35)', fontSize: 13, maxWidth: 200 }}>
              Canada's moving platform built for transparency.
            </Typography>
          </Box>

          {/* Nav links */}
          <Box>
            <Typography variant="overline" sx={{ color: 'rgba(255,255,255,0.25)', letterSpacing: 3, fontSize: 10, display: 'block', mb: 1.5 }}>
              EXPLORE
            </Typography>
            <Stack spacing={1}>
              {navLinks.map(link => (
                <Typography key={link.to} component={Link} to={link.to} sx={linkSx}>
                  {link.label}
                </Typography>
              ))}
            </Stack>
          </Box>

          {/* Legal links */}
          <Box>
            <Typography variant="overline" sx={{ color: 'rgba(255,255,255,0.25)', letterSpacing: 3, fontSize: 10, display: 'block', mb: 1.5 }}>
              LEGAL
            </Typography>
            <Stack spacing={1}>
              {legalLinks.map(link => (
                <Typography
                  key={link.to}
                  component={link.external ? 'a' : Link}
                  {...(link.external ? { href: link.to } : { to: link.to })}
                  sx={linkSx}
                >
                  {link.label}
                </Typography>
              ))}
            </Stack>
          </Box>
        </Box>

        <Divider sx={{ borderColor: 'rgba(255,255,255,0.07)', mb: 3 }} />

        {/* Bottom row */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
          <Typography sx={{ color: 'rgba(255,255,255,0.2)', fontSize: 13 }}>
            © {new Date().getFullYear()} Movd Technologies Inc. All rights reserved.
          </Typography>
          <Typography sx={{ color: 'rgba(255,255,255,0.15)', fontSize: 12 }}>
            Serving all of Canada
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}
